import PropTypes from 'prop-types'
import { Tab } from '@mui/material'
import { Badge } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab'

import styles from './styles'

const CustomTabs = ({ extraContent, value, tabs, onTabChange = () => {} }) => {
  const handleChange = (event, newValue) => {
    onTabChange(newValue)
  }

  return (
    <TabContext value={value}>
      <TabList
        onChange={handleChange}
        variant="scrollable"
        textColor="primary"
        indicatorColor="primary"
        scrollButtons="auto"
        aria-label="simple tabs example"
      >
        {tabs.map(tab => (
          <Tab
            key={tab.value}
            value={tab.value}
            sx={styles.tab}
            label={
              <>
                {Boolean(tab.badgeValue) ? (
                  <Badge
                    badgeContent={tab.badgeValue}
                    color="primary"
                    sx={styles.badge}
                  >
                    {tab.label}
                  </Badge>
                ) : (
                  tab.label
                )}
              </>
            }
          />
        ))}
        {extraContent ? extraContent : null}
      </TabList>
      {tabs.map(tab => (
        <TabPanel key={tab.value} value={tab.value}>
          {tab.content}
        </TabPanel>
      ))}
    </TabContext>
  )
}

CustomTabs.propTypes = {
  value: PropTypes.string,
  tabs: PropTypes.array.isRequired,
  onTabChange: PropTypes.func,
  extraContent: PropTypes.node,
}

export default CustomTabs
